/**
 * Points <meta name="theme-color"> (the mobile browser bar / installed-app
 * title bar) at the current theme. Index.cshtml renders a static value for
 * the first paint; the theme providers keep it in step on every switch.
 */
export const setThemeColorMeta = (color: string | undefined): void => {
    if (!color || typeof document === "undefined") return;
    let meta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
    if (!meta) {
        meta = document.createElement("meta");
        meta.name = "theme-color";
        document.head.appendChild(meta);
    }
    if (meta.content !== color) meta.content = color;
};
